import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i2$1 from '@anb/ng-forms';
import { DropdownModel, AnbFormElementsModule } from '@anb/ng-forms';
import { throwError, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpParams, HttpClientJsonpModule } from '@angular/common/http';
import * as i2 from '@anb/ng-configuratie';

class BaseService {
    constructor() { }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError(err) {
        return throwError(err);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: BaseService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: BaseService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: BaseService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

/**
 * Address search service: Url is fetched from parameter store
 * VERSION 4
 *
 * export
 * class AddressSearchService
 * extends
 */
class AddressSearchV4Service extends BaseService {
    constructor(httpClient, configuratieService) {
        super();
        this.httpClient = httpClient;
        this.configuratieService = configuratieService;
        this.api = 'GEOPUNT_URL';
        this.geopuntKey = '/appl/configuratieservice/geo-url/geolocation';
        this.apiVersionPath = '/v4';
        this.api = `${configuratieService.getValue(this.geopuntKey)}${this.apiVersionPath}`;
    }
    /**
     * Provides auto-completion functionality for a free form single search line.
     * example: GET v4/Suggestion?q={q}&c={c}
     *
     * @param q A free form search string. May contain community names,
     * sub-community area names, zip codes, street names, house numbers or parts thereof. A minimum of two characters is required.
     * @param c Optional] The maximum number of items you want to retrieve in the result.
     *  You may not ask more than 25 items. If omitted defaults to 5.
  
     * @returns  Observable<{ 'SuggestionResult': string[] }>
     * @memberof AddressSearchService
     */
    getAddressSuggestion(q, c) {
        let params = new HttpParams();
        params = params.append('q', q);
        params = params.append('c', c.toString());
        return this.httpClient
            .jsonp(`${this.api}/suggestion?${params.toString()}`, 'callback')
            .pipe(catchError(this.handleError));
    }
    /**
     * Geocoding provides the location of an address or a poi. Reverse geocoding provides the closest address based on a given location.
     * example: GET v4/Location?q={q}&latlon={latlon}&xy={xy}&type={type}&c={c}
     *
     * @param q [Optional] A free form search string. May contain community names, sub-community area names,
     * zip codes, street names, house numbers, poi names, coordinates or parts thereof. A minimum of two characters is required.
     * @param lation [Optional] A coordinate in WGS84 projection.
     * Input takes the form [lat,lon] where lat and lon are provided in decimal degrees.
     * @param xy [Optional] A coordinate in Lambert-72 projection.
     * Input takes the form [x,y] where x and y are provided in meters.
     * @param type [Optional] The location types you want to restrict the result to.
     * Valid types are 'Municipality', 'Thoroughfarename', 'Housenumber'. The filter has no effect on reverse geocoding requests.
     * @param  c [Optional] The maximum number of items you want to retrieve in the result.
     * You may not ask more than 5 items. If omitted defaults to 1.
     * @returns
     * @memberof AddressSearchService
     */
    getLocation(q = null, lation = null, xy = null, type = null, c = null) {
        let params = new HttpParams();
        if (q) {
            params = params.append('q', q);
        }
        if (lation) {
            params = params.append('lation', lation);
        }
        if (xy) {
            params = params.append('xy', xy.toString());
        }
        if (c) {
            params = params.append('c', c.toString());
        }
        if (type) {
            params = params.append('type', type);
        }
        return this.httpClient
            .jsonp(`${this.api}/location?${params.toString()}`, 'callback')
            .pipe(catchError(this.handleError));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AddressSearchV4Service, deps: [{ token: i1.HttpClient }, { token: i2.AnbNgConfiguratieService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AddressSearchV4Service }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AddressSearchV4Service, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.AnbNgConfiguratieService }]; } });

class AddressSearchInputFieldComponent {
    constructor(addressSearchService) {
        this.addressSearchService = addressSearchService;
        this.suggesiontResult$ = new EventEmitter();
        this.locationResult$ = new EventEmitter();
        this.autoCompleteLoading = false;
        this.subs = new Subscription();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onAutoCompleteValueChange(event) {
        if (!event || event.length < 2) {
            this.searchResults = null;
            return;
        }
        const sub = this.addressSearchService.getAddressSuggestion(event, 5).subscribe((result) => {
            this.searchResults = new Array();
            if (result.SuggestionResult.length > 0) {
                this.suggesiontResult$.next(result);
                result.SuggestionResult.forEach((element) => {
                    this.searchResults.push(new DropdownModel(element, element));
                });
            }
            else {
                this.searchResults = new Array();
            }
            this.autoCompleteLoading = false;
        });
        this.subs.add(sub);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onValueSelected(event) {
        const sub = this.addressSearchService.getLocation(event).subscribe((result) => {
            this.locationResult$.next(result);
        });
        this.subs.add(sub);
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AddressSearchInputFieldComponent, deps: [{ token: AddressSearchV4Service }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.7", type: AddressSearchInputFieldComponent, selector: "anb-address-search-field", inputs: { id: "id", placeholder: "placeholder" }, outputs: { suggesiontResult$: "suggesiontResult$", locationResult$: "locationResult$" }, ngImport: i0, template: "<anb-input-text-autocomplete [id]=\"id\" [searchResults]=\"searchResults\" [isLoading]=\"autoCompleteLoading\"\n    (onValueChange)=\"onAutoCompleteValueChange($event)\" [placeholder]=\"placeholder\"\n    (onValueSelected$)=\"onValueSelected($event)\">\n</anb-input-text-autocomplete>", styles: [""], dependencies: [{ kind: "component", type: i2$1.AnbInputTextAutocompleteComponent, selector: "anb-input-text-autocomplete", inputs: ["placeholder", "maxlength", "inputType", "searchResults", "isLoading", "browserAutocomplete", "noResultsMessageEnabled"], outputs: ["onValueSelected$", "onFocus$", "onModelSelected$"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AddressSearchInputFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-address-search-field', template: "<anb-input-text-autocomplete [id]=\"id\" [searchResults]=\"searchResults\" [isLoading]=\"autoCompleteLoading\"\n    (onValueChange)=\"onAutoCompleteValueChange($event)\" [placeholder]=\"placeholder\"\n    (onValueSelected$)=\"onValueSelected($event)\">\n</anb-input-text-autocomplete>" }]
        }], ctorParameters: function () { return [{ type: AddressSearchV4Service }]; }, propDecorators: { id: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], suggesiontResult$: [{
                type: Output
            }], locationResult$: [{
                type: Output
            }] } });

class AddressSearchModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AddressSearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.7", ngImport: i0, type: AddressSearchModule, declarations: [AddressSearchInputFieldComponent], imports: [CommonModule, AnbFormElementsModule, HttpClientJsonpModule], exports: [AddressSearchInputFieldComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AddressSearchModule, providers: [AddressSearchV4Service], imports: [CommonModule, AnbFormElementsModule, HttpClientJsonpModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AddressSearchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, AnbFormElementsModule, HttpClientJsonpModule],
                    declarations: [AddressSearchInputFieldComponent],
                    exports: [AddressSearchInputFieldComponent],
                    providers: [AddressSearchV4Service],
                }]
        }] });

const AnbAddressSearchParameterKeys = ['/appl/configuratieservice/geo-url/geolocation'];

/*
 * Public API Surface of anb-ng-address-search
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddressSearchInputFieldComponent, AddressSearchModule, AnbAddressSearchParameterKeys };
